module.exports = __webpack_public_path__ + "media/images/logos/logo-ucaf-6c7c7aeea02f11388e9e1c7f7a97d0f6.png";